var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/paperclip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3333 5L6.32167 12.155C6.00904 12.4676 5.83341 12.8916 5.83341 13.3338C5.83341 13.7759 6.00904 14.1999 6.32167 14.5125C6.63429 14.8251 7.0583 15.0008 7.50042 15.0008C7.94253 15.0008 8.36654 14.8251 8.67917 14.5125L15.6908 7.3575C16.316 6.73236 16.6672 5.88449 16.6672 5.00042C16.6672 4.11634 16.316 3.26847 15.6908 2.64333C15.0657 2.0182 14.2178 1.667 13.3337 1.667C12.4497 1.667 11.6018 2.0182 10.9767 2.64333L3.99417 9.76917C3.52367 10.2321 3.14947 10.7835 2.89317 11.3918C2.63686 12 2.50352 12.653 2.50083 13.313C2.49814 13.973 2.62616 14.6271 2.87751 15.2374C3.12885 15.8477 3.49854 16.4022 3.96526 16.8689C4.43197 17.3356 4.98648 17.7053 5.59678 17.9567C6.20709 18.208 6.86112 18.336 7.52115 18.3333C8.18118 18.3306 8.83415 18.1973 9.44239 17.941C10.0506 17.6847 10.6021 17.3105 11.065 16.84L18.0475 9.71417",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#87958F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.8d6183471d2d694d9fd9edb247492ce4.svg";
export { ForwardRef as ReactComponent };